
const ConsigneeEmailType = {
  DELIVERY_REMINDER: 'delivery_reminder',
  RESET_PASSWORD: 'consignee-password-reset',
  GRN_REPORT_RELEASE: 'grn-report-release',
  TRANSPORTER_GRN_UPDATE: 'transporter-grn-update',
  TWO_FACTOR_AUTH_OTP: 'two_factor_auth_otp',
};

const ConsigneeEmailSubject = {
  RESET_PASSWORD: ' Request to reset Pando account password',
  GRN_REPORT_RELEASE: 'Indent ID #firstArgument# has been delivered to #secondArgument#!',
  TRANSPORTER_GRN_UPDATE: 'Transporter submitted GRN for indent Id #firstArgument#',
};

const ConsigneeEmailDateFormat = 'hh:mm A';

module.exports = { ConsigneeEmailType, ConsigneeEmailSubject, ConsigneeEmailDateFormat };
